<template>
  <div class="pd-top-15">
    <v-container fluid>
      <v-breadcrumbs class="fadeIn breadcrumb" :items="[
        {
          text: this.$t('navDrawer.home').toUpperCase(),
          disabled: false,
          to: {name: 'home'},
          exact: true
        },
        {
          text: this.$t('navDrawer.maestros').toUpperCase(),
          disabled: true
        }
      ]">
        <v-icon slot="divider">chevron_right</v-icon>
      </v-breadcrumbs>

      <v-layout wrap pt-3>
          <v-tabs vertical background-color="transparent"
            class="transparentTabs">
            <v-tab v-for="(item, index) in items" :key="index + '-tab'" @change="lanzarCambioPestana(item.tipo)">
              <v-row justify="center" align="center">
                {{ item.name }}
              </v-row>
            </v-tab>
            <v-tab-item v-for="(item, index) in items" :key="index + '-tab-item'">
              <v-container fluid>
                <keep-alive>
                  <component :is="item.tipo" />
                </keep-alive>
              </v-container>
            </v-tab-item>
          </v-tabs>
      </v-layout>
    </v-container>
  </div>
</template>


<script>
import { mapGetters } from 'vuex'
import oficios from './maestros/oficios'
import suboficios from './maestros/suboficios'
import provOficioPromocion from './maestros/provOficioPromo'
import inmuEspeciales from './maestros/inmueblesEspeciales'
import inmuEspecialesProm from './maestros/inmueblesEspecialesPromo'
import clientesEspeciales from './maestros/clientesEspeciales'
import clientesEspecialesPromo from './maestros/clientesEspecialesPromo'
import tiposParte from './maestros/tiposParte'
import tiposInmueble from './maestros/tiposInmueble'
import tiposReclamacion from './maestros/tiposReclamacion'
import incidenciasPredefinidas from './maestros/incidenciasPredef'
import estanciasTipoInmueble from './maestros/estanciasTipoInmueble'
import proveedores from './maestros/proveedores'
import mensajesTipoEstado from './maestros/mensajesTipoEstado'

export default {
  components: {
    oficios,
    suboficios,
    provOficioPromocion,
    inmuEspeciales,
    inmuEspecialesProm,
    clientesEspeciales,
    clientesEspecialesPromo,
    tiposParte,
    tiposInmueble,
    tiposReclamacion,
    incidenciasPredefinidas,
    estanciasTipoInmueble,
    proveedores,
    mensajesTipoEstado
  },
  computed: {
    ...mapGetters({
      idubapi: 'login/idubapi'
    }),
    localization () {
      return this.$t('maestros')
    },
    items () {
      let items = [
        {
          name: this.localization.oficios.title,
          link: '/maestros/nuevo-oficio',
          tipo: 'oficios'
        },
        {
          name: this.localization.suboficios.title,
          link: '/maestros/nuevo-suboficio',
          tipo: 'suboficios'
        },
        {
          name: this.localization.proveedores.title,
          link: '/maestros/proveedores',
          tipo: 'proveedores'
        },
        {
          name: this.localization.proveedoresPorOficio.title,
          link: '/maestros/prov-oficio-promo',
          tipo: 'provOficioPromocion'
        },
        {
          name: this.localization.inmueblesEspeciales.title,
          link: '/maestros/inmuebles-especiales',
          tipo: 'inmuEspeciales'
        },
        {
          name: this.localization.inmueblesEspecialesPorPromocion.title,
          link: '/maestros/inmuebles-especiales-promo',
          tipo: 'inmuEspecialesProm'
        },
        {
          name: this.localization.clientesEspeciales.title,
          link: '/maestros/clientes-especiales',
          tipo: 'clientesEspeciales'
        },
        {
          name: this.localization.clientesEspecialesPorPromocion.title,
          link: '/maestros/clientes-especiales-promo',
          tipo: 'clientesEspecialesPromo'
        },
        {
          name: this.localization.tiposParte.title,
          link: '/maestros/tipos-parte',
          tipo: 'tiposParte'
        },
        {
          name: this.localization.tiposInmueble.title,
          link: '/maestros/tipos-inmueble',
          tipo: 'tiposInmueble'
        },
        {
          name: this.localization.tiposReclamacion.title,
          link: '/maestros/tipos-reclamacion',
          tipo: 'tiposReclamacion'
        },
        {
          name: this.localization.incidenciasPredefinidas.title,
          link: '/maestros/incidencias-predefinidas',
          tipo: 'incidenciasPredefinidas'
        },
        {
          name: this.localization.estanciasTipoInmueble.title,
          link: '/maestros/estancias-tipo-inmueble',
          tipo: 'estanciasTipoInmueble'
        }

      ]

      if(this.idubapi.motor !== 'SIN_BD') {
        items.push({
          name: this.localization.mensajesTipoEstado.title,
          link: '/maestros/mensajes-tipo-estado',
          tipo: 'mensajesTipoEstado'
        })
      }
      return items

    }
  },
  methods: {
    goTo (routeName) {
      console.log(routeName)
      this.$router.push({name: routeName})
    },
    lanzarCambioPestana(routeName) {
      console.log(routeName)
    }
  }
}
</script>

<style>
.v-icon.v-icon.v-icon--link {
  display: flex !important;
}
.clickable {
  cursor: pointer;
}
</style>
